import { Button, Result, Typography } from 'antd'
// @ts-ignore
import { getLocale } from 'umi'
const { Text, Paragraph } = Typography

const defaultLocale = 'en-US'

export default function result404({ error }: { error: any }) {
  const currentLocale = getLocale ? getLocale() : defaultLocale

  const url = window.location.href.replace(
    (window.location.origin || '') + '/#',
    '',
  )

  return (
    <Result
      status="404"
      title="404"
      subTitle={
        currentLocale === defaultLocale
          ? 'Sorry, the page you visited does not exist.'
          : '页面不存在'
      }
      extra={
        <div>
          <Button type="primary" onClick={() => window.location.reload()}>
            {currentLocale === defaultLocale ? 'Reload' : '再试一次'}
          </Button>
          <Paragraph mark>
            {currentLocale === defaultLocale ? 'masterPageUrl' : '页面地址'}：
            <Text copyable>{url}</Text>
          </Paragraph>
        </div>
      }
    />
  )
}
